import React from 'react'
import Helmet from 'components/Helmet'
import Content, { Col } from 'components/Content'
import ContactForm from 'components/ContactForm'
import styles from './styles.module.scss'
import config from 'config'

export default function ContactPage({ data }) {
  return (
    <main>
      <Helmet
        title='Contact Our Studio - Cali Dance XV'
        description='Ready to start your dance choreography? Contact us here to get started with Cali Dance XV, a dance studio based in Houston, Texas.'
      />
      <Content>
        <Col>
          <h1>Contact Us</h1>
          <p>
            Want to learn more? Please fill out the form below if you'd like more information about us and our services.
          </p>
        </Col>
      </Content>
      <Content>
        <Col size='half'>
          <ContactForm />
        </Col>
        <Col size='half'>
          <h3>Cali Dance XV</h3>
          <p>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={config.directions}
            >
              5812 Hwy 6 N<br />Houston, TX 77084
            </a>
          </p>
          <div className={styles.contactContainer}>
            <p>
              <a href={config.tel}>Phone: (832) 416-5026</a>
            </p>
            <p>
              <a href={config.mailto}>Email: calidancestudio@hotmail.com</a>
            </p>
          </div>
          <p>We look forward to working with you.</p>
        </Col>
      </Content>
    </main>
  )
}



// WEBPACK FOOTER //
// ./src/pages/contact/index.js